/* eslint-disable react/jsx-no-bind */
import React from 'react';
import cx from 'classnames';
import { withRouter } from 'react-router';
import { get, has, isNil } from 'lodash';
import { connect } from 'react-redux';
import withAppConfig from 'shared-components/withAppConfig';

import Button from '@material-ui/core/Button';
import Popover from '@material-ui/core/Popover';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import AddIcon from '@material-ui/icons/Add';

// import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { withStyles } from '@material-ui/core/styles';

import { element, bool, shape, string, number } from 'prop-types';

import styles from './styles/index.scss';

import { getConfig } from 'modules/config';
import { getStripeKey, updateOrganizationPayment } from 'modules/user/helpers';

const newResourceRoutes = [
  {
    label: 'Flow',
    path: '/',
    iconClassName: 'icon-job-bundles',
  },
  {
    label: 'Engine',
    path: '/engines/overview/new',
    iconClassName: 'icon-engines',
    onClick: 'mountAddNewEngineWidget',
  },
  {
    label: 'Application',
    path: '/applications/overview/new',
    iconClassName: 'icon-applications',
    onClick: 'mountAddNewAppWidget',
  },
  {
    label: 'Schema',
    path: '/data-schemas/overview/new',
    iconClassName: 'icon-data',
  },
];

const customStyle = (theme) => ({
  paper: {
    padding: '8px 0',
  },
});

@connect((state) => ({
  graphqlUri: getConfig(state).services.graphqlUri,
  config: state.config,
  organizationId: state.user.user.organization.organizationId,
  email: state.user.user.organization.organizationName,
}))
@withAppConfig
class TopBar extends React.Component {
  static propTypes = {
    config: shape({
      apiRoot: string,
    }),
    organizationId: number,
    email: string,
    rightElement: element,
    leftElement: element,
    appBarOffset: bool,
    classes: shape({
      paper: string,
    }),
    router: shape({}),
    graphqlUri: string,
    appConfig: shape({}),
    isCollapsed: bool,
  };

  state = {
    open: false,
    anchorEl: null,
    paymentPlanKey: null,
    stripeKey: null,
  };

  async componentDidMount() {
    this.getStripeKeys();
  }

  mountAddNewEngineWidget = () => {
    const microFrontend = {
      name: 'ENGINE_CENTER_NEW',
      config: {
        name: 'Create New Engine',
      },
    };

    const panelConfig = {
      type: 'APP_BAR_PANEL_TEMPLATE',
      header: {
        title: 'Create New Engine',
        divider: true,
      },
      marginTop: 55,
      size: 'xlarge',
      zIndex: 1000,
    };

    window.aiware.mountPanel({
      panelId: 'ENGINE_CENTER_NEW',
      microFrontend: microFrontend,
      panelConfig: panelConfig,
    });
  };

  mountAddNewAppWidget = () => {
    const microFrontend = {
      name: 'APP_CENTER_NEW',
      config: {
        name: 'New App Onboarding',
      },
    };

    const panelConfig = {
      type: 'APP_BAR_PANEL_TEMPLATE',
      header: {
        title: 'New App Onboarding',
        divider: true,
      },
      marginTop: 55,
      size: 'xlarge',
      zIndex: 1000,
    };

    window.aiware.mountPanel({
      panelId: 'APP_CENTER_NEW',
      microFrontend: microFrontend,
      panelConfig: panelConfig,
    });
  };

  getStripeKeys = () => {
    getStripeKey(this.props.config.apiRoot, this.props.organizationId).then(
      (result) => {
        if (has(result, 'data.pk')) {
          this.setState({ stripeKey: result.data.pk });
          this.setState({ paymentPlanKey: result.data.id });
        }
        return;
      }
    );
  };

  onToken = async (stripeObj) => {
    let res = await updateOrganizationPayment(
      this.props.config.apiRoot,
      this.props.organizationId,
      stripeObj
    );
    if (res) {
      this.setState({ paymentPlanKey: true });
    }
  };

  handleOpenMenu = (event) => {
    event.preventDefault();

    this.setState({
      open: true,
      anchorEl: event.currentTarget,
    });
  };

  handleEngineBack = (event) => {
    event.preventDefault();
    if (this.props.router.location.pathname.includes('automate-studio')) {
      this.props.router.replace('/automate-studio/overview');
      return;
    }
    this.props.router.replace('/engines/overview');
  };

  handleRedirect = ({ label, path, onClick }) => {
    this.handleRequestClose();

    if (!isNil(onClick)) {
      this[onClick]();
      return;
    }

    if (path) {
      this.props.router.push(path);
    }

    if (label === 'Flow') {
      const automatePageUri = get(
        window.config,
        'pageUris.automatePageUri',
        'https://automate.veritone.com'
      );
      window.open(`${automatePageUri}`, '_blank');
    }
  };

  handleRequestClose = () => {
    this.setState({
      open: false,
    });
  };

  handleUpgrade = () => {
    let { appConfig } = this.props;
    let adminPageUrl = get(appConfig, 'pageUris.adminPageUri');
    window.open(
      `${adminPageUrl}/organizations/${this.props.organizationId}/billing`
    );
  };

  render() {
    const containerClasses = cx(styles['topBar'], {
      [styles['topBar--appBar-offset']]: this.props.appBarOffset,
      [styles['topBar--collapsed']]: this.props.isCollapsed,
    });

    const rightGroupClasses = cx(styles['actions-container__item']);
    const leftGroupClasses = cx(styles['actions-container__item']);

    return (
      <div className={containerClasses}>
        <div
          className={
            this.props.isCollapsed
              ? styles['cta-container--collapsed']
              : styles['cta-container']
          }
        >
          {!this.props.isCollapsed && (
            <Button
              data-test="sidebar-create-new"
              data-pendo-walkthrough-id="topbar-create-new"
              className={styles.cta}
              variant="contained"
              color="primary"
              onClick={this.handleOpenMenu}
              startIcon={<AddIcon />}
              size="large"
            >
              Create New
            </Button>
          )}
          <Popover
            data-test="sidebar-create-new-popover"
            open={this.state.open}
            anchorEl={this.state.anchorEl}
            anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
            onClose={this.handleRequestClose}
            classes={{
              paper: this.props.classes.paper,
            }}
          >
            {newResourceRoutes.map(
              ({ label, path, iconClassName, onClick, icon }) => {
                return (
                  <MenuItem
                    key={label}
                    value={path}
                    onClick={() =>
                      this.handleRedirect({ label, path, onClick })
                    }
                  >
                    <ListItemIcon className={styles.listItemIcon}>
                      <span
                        className={cx(iconClassName, styles['popover-icon'])}
                      />
                    </ListItemIcon>
                    <ListItemText>{label}</ListItemText>
                  </MenuItem>
                );
              }
            )}
          </Popover>
        </div>

        {(this.props.leftElement || this.props.rightElement) && (
          <div className={styles['actions-container']}>
            <div className={leftGroupClasses}>{this.props.leftElement}</div>

            <div className={rightGroupClasses}>{this.props.rightElement}</div>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(withStyles(customStyle)(TopBar));



// WEBPACK FOOTER //
// ./src/client/shared-components/TopBar/index.js